import axios from 'axios';
import resolve  from './../resolver.js';
import checkJwt from './../../Global/jwtChecker' 
import logout from './../../Global/logout' 

export default async function CreateTransaction(
    data,
    note
) {
    const unHashedJwt = await checkJwt()    

    if(!unHashedJwt){
        logout()
    }

    var tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
    var localISOTime = (new Date(Date.now() - tzoffset)).toISOString()

    return await resolve(
        axios( process.env.REACT_APP_DEFAULT_API_PREFIX + 'provider/user/transactions', {
            method: 'post',
            headers: { 'Authorization' : unHashedJwt},
            data: {
                "transaction_type": 2,
                "transaction_id": "sto" + data.transaction_id,
                "transaction_date": data.transaction_date,
                "payment_type": data.payment_type,
                "country": data.country,
                "country_code": data.country_code,
                "processed_date": localISOTime,
                "e-mail": data.email,
                "customer_name": data.customer_name,
                "customer_id": data.customer_id,
                "amount": data.amount * -1,
                "currency": data.currency_short,
                "item_name": data.item_name,
                "item_code": data.item_code,
                "item_quantity": data.item_quantity,
                "transaction_log": JSON.stringify(data),
                "cancellation": data.transaction_id,
                "note": note
            }
        }).then(res => res)
        .catch(error => error.response.data)
    );
}